export enum PageCountEnum {
  THIRTY = "30",
  SIXTY = "60",
  NINTY = "90",
  TWO_HUNDRED = "200",
}
